"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var InfoIcon = function InfoIcon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 6 8",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.52578 1.32988C4.11562 0.970313 3.57422 0.773438 3 0.773438C2.42578 0.773438 1.88437 0.97168 1.47422 1.32988C1.04766 1.70313 0.8125 2.20488 0.8125 2.74219V2.84609C0.8125 2.90625 0.861719 2.95547 0.921875 2.95547H1.57812C1.63828 2.95547 1.6875 2.90625 1.6875 2.84609V2.74219C1.6875 2.13926 2.27676 1.64844 3 1.64844C3.72324 1.64844 4.3125 2.13926 4.3125 2.74219C4.3125 3.16738 4.01172 3.55703 3.54551 3.73613C3.25566 3.84688 3.00957 4.04102 2.8332 4.29531C2.6541 4.55508 2.56113 4.8668 2.56113 5.18262V5.47656C2.56113 5.53672 2.61035 5.58594 2.67051 5.58594H3.32676C3.38691 5.58594 3.43613 5.53672 3.43613 5.47656V5.16621C3.43684 5.03349 3.47753 4.90405 3.55288 4.7948C3.62824 4.68554 3.73478 4.60152 3.85859 4.55371C4.66523 4.24336 5.18613 3.53242 5.18613 2.74219C5.1875 2.20488 4.95234 1.70313 4.52578 1.32988ZM2.45312 7.00781C2.45312 7.15285 2.51074 7.29195 2.6133 7.39451C2.71586 7.49707 2.85496 7.55469 3 7.55469C3.14504 7.55469 3.28414 7.49707 3.3867 7.39451C3.48926 7.29195 3.54688 7.15285 3.54688 7.00781C3.54688 6.86277 3.48926 6.72367 3.3867 6.62111C3.28414 6.51855 3.14504 6.46094 3 6.46094C2.85496 6.46094 2.71586 6.51855 2.6133 6.62111C2.51074 6.72367 2.45312 6.86277 2.45312 7.00781Z"
  }));
};
InfoIcon.propTypes = _utils.iconProps;
InfoIcon.defaultProps = {
  color: '#83A8AF',
  width: '14',
  height: '14'
};
var _default = InfoIcon;
exports.default = _default;